import { BaseWebComponentController, IListenerConfig } from '../../../../../framework/BaseWebComponentController';
import { templateMspInProductTrialsOverlayWindow } from '../view/template';
import { MspInProductTrialsOverlayContentView } from '../view/MspInProductTrialsOverlayContentView';
import { MspInProductTrialsOverlayContentWebComponent } from '../component/MspInProductTrialsOverlayContentWebComponent';
import { ButtonEvents } from '../../../../../ui/gzButton/types';
import {
  MspInProductTrialsOverlayWindowEventType,
  OnMspInProductTrialsOverlayWindowButtonClick,
} from '../events/MspInProductTrialsOverlayWindowEventType';
import { MspInProductTrialsOverlayWindowType } from '../../mspInProductTrialsOverlaysApp/types/MspInProductTrialsOverlayWindowType';

export class MspInProductTrialsOverlayContentController extends BaseWebComponentController {
  public component: MspInProductTrialsOverlayContentWebComponent;
  public view: MspInProductTrialsOverlayContentView;
  public viewConstructor: typeof MspInProductTrialsOverlayContentView;

  constructor(component: MspInProductTrialsOverlayContentWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: MspInProductTrialsOverlayContentView,
      viewTemplate: templateMspInProductTrialsOverlayWindow,
    });
  }

  async getDataForView(): Promise<{ inProductTrialsOverlayWindowType: MspInProductTrialsOverlayWindowType }> {
    return {
      inProductTrialsOverlayWindowType: this.component.mspInProductTrialsOverlayWindowType,
    };
  }

  public computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$button1,
        event: ButtonEvents.CLICK,
        callback: () => {
          this.handleButtonClick(this.view.overlayWindowConfig.buttons.button1.event);
        },
      },
      {
        element: this.view.dom.$button2,
        event: ButtonEvents.CLICK,
        callback: () => {
          this.handleButtonClick(this.view.overlayWindowConfig.buttons.button2.event);
        },
      },
      {
        element: this.view.dom.$button3,
        event: ButtonEvents.CLICK,
        callback: () => {
          this.handleButtonClick(
            this.view.overlayWindowConfig.buttons.button3?.event ?? MspInProductTrialsOverlayWindowEventType.Default
          );
        },
      },
    ];
  }

  private handleButtonClick(eventType: MspInProductTrialsOverlayWindowEventType) {
    this.component.dispatchEvent(new OnMspInProductTrialsOverlayWindowButtonClick(eventType));
  }
}
